import React from 'react';

import './styles.css';

function List({ children, className }) {
  return <ul className={`List ${className || ''}`}>{children}</ul>;
}

export default List;

export { default as ListItem } from './ListItem';
